export default "__VITE_ASSET__B6H3GPZV__"